import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loading from './Loading/Loading';

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, ...rest }) => {
  const { isAuthenticated, isLoading, requireAuth } = useAuth();

  if (isLoading) {
    return <Loading />; // or a loading spinner
  }

  if (!isAuthenticated && requireAuth) {
    return <Redirect to="/login" />;
  }

  return <Route {...rest} component={Component} />;
};

export default PrivateRoute; 